import * as React from 'react';
import * as DateFns from 'date-fns';
import { es, enUS } from 'date-fns/locale';

interface CalendarDayProps {
  day: Date;
  tabIndex?: number;
  index?: number;
  focus?: boolean;
  language?: 'enUS' | 'es';
  state: 'off' | 'unavailable' | 'selected' | 'priority' | 'available';
  onSelect?: Function;
  onNextDay?: Function;
  onPrevDay?: Function;
  onFocus?: Function;
  onTab?: Function;
  onShiftTab?: Function;
}

export default function CalendarDay(props: CalendarDayProps) {
  const buttonRef: any = React.useRef(null);

  React.useEffect(() => {
    if (props.focus && buttonRef && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, [props.focus]);

  if (props.state === 'off' || props.state === 'unavailable') {
    return (
      <div key={props.day.toDateString()} className={`day ${props.state}`}>
        <span className="state" />
        <span>{props.day.getDate()}</span>
      </div>
    );
  }
  const dayClass =
    props.state === 'selected' || props.state === 'priority'
      ? ` ${props.state}`
      : '';

  return (
    <button
      key={props.day.toDateString()}
      onFocus={() => {
        if (props.onFocus !== undefined) {
          props.onFocus(props.index, props.day);
        }
      }}
      tabIndex={props.tabIndex}
      aria-label={DateFns.format(props.day, 'MMM dd yyyy', {
        locale: props.language === 'es' ? es : enUS
      })}
      ref={buttonRef}
      type="button"
      onClick={() => {
        if (props.onSelect !== undefined) {
          props.onSelect(props.day);
        }
      }}
      onKeyDown={e => {
        if (e.key === 'ArrowRight') {
          if (props.onNextDay !== undefined) {
            props.onNextDay(props.index);
          }
        } else if (e.key === 'ArrowLeft') {
          if (props.onPrevDay !== undefined) {
            props.onPrevDay(props.index);
          }
        } else if (e.key === 'Tab') {
          e.preventDefault();
          if (e.shiftKey) {
            if (props.onShiftTab !== undefined) {
              props.onShiftTab(props.day);
            }
          } else if (props.onTab !== undefined) {
            props.onTab(props.day);
          }
        }
      }}
      className={`day${dayClass}${props.focus ? ' active' : ''}`}
    >
      <span className="state" />
      <span>{props.day.getDate()}</span>
    </button>
  );
}
